import { AdjustmentType } from 'enums';
import { AdjustmentDetailSidebar, AdjustmentDetailSidebarProps, CurrencyValue } from 'components';
import { InvoiceDetail } from 'types';
import styles from './InvoiceDetailSidebar.module.scss';
import { classNames } from '@progress/kendo-react-common'
import { formatDecimalNumber } from 'functions';

type InvoiceDetailSidebarProps = {
    selectedDetail: InvoiceDetail,
} & AdjustmentDetailSidebarProps;

export default function InvoiceDetailSidebar(props: InvoiceDetailSidebarProps) {
    const { selectedDetail } = props;
    const { adjustmentTypeId } = selectedDetail;
    
    return (
        <AdjustmentDetailSidebar {...props}>
            <div className={styles.section}>
                <div className={styles.heading}>
                    Invoice {selectedDetail.invoiceId}
                </div>
            </div>           
            <ItemDetails detail={selectedDetail} />
            {adjustmentTypeId === AdjustmentType.Quantity
                ? <QuantityAdjustmentDetailsPane detail={selectedDetail} />
                : <PricingAdjustmentDetailsPane detail={selectedDetail} />
            }
        </AdjustmentDetailSidebar>
    )
};

type DetailProps = {
    detail: InvoiceDetail
};

const ItemDetails = ({ detail }: DetailProps) => (
    <div className={styles.section}>
        <div className={styles.heading}>
            Item Details
        </div>

        {detail.description && 
            <DetailItem
                name='Description:'
                value={detail.description}
            />
        }
      
        <DetailItem
            name='Dot Item Number:'
            value={detail.inventoryItemId}
        />
        <DetailItem
            name='Manufacturer Number:'
            value={detail.manufacturerItemNumber}
        />
        <DetailItem
            name='UPC:'
            value={detail.upcNumber}
        />
    </div>
);

const PricingAdjustmentDetailsPane = ({ detail }: DetailProps) => (
    <div className={styles.section}>
        <div className={styles.heading}>
            Adjustment Details
        </div>
        <DetailItem
            name='Quantity Ordered:'
            value={detail.quantity}
        />
        <DetailItem
            name='Invoiced Price:'
            value={formatDecimalNumber(detail?.originalPrice, 3)}
        />
        <DetailItem
            name='Adjusted Price:'
            value={formatDecimalNumber(detail?.adjustmentUnitPrice, 3)}
        />
        <DetailItem
            name='Total Adjustments:'
            value={<CurrencyValue value={detail?.adjustmentAmount} />}
        />
    </div>
);

const QuantityAdjustmentDetailsPane = ({ detail }: DetailProps) => (
    <div className={styles.section}>
        <div className={styles.heading}>
            Adjustment Details
        </div>
        <DetailItem
            name='Original Quantity:'
            value={detail.voucherQuantity}
        />
        <DetailItem
            name='Quantity Received:'
            value={detail.voucherQuantity+detail.quantity}
        />
        <DetailItem
            name='Quantity Adjusted By:'
            value={detail.quantity}
        />
        <DetailItem
            name='Unit Price:'
            value={<CurrencyValue value={detail?.adjustmentUnitPrice} />}
        />
        <DetailItem
            name='Total Adjustments:'
            value={<CurrencyValue value={detail?.adjustmentAmount} />}
        />
        
    </div>
);

type ElementProps = {
    name: string,
    value: any,
    valueClass?: string
};

const DetailItem = ({ name, value, valueClass }: ElementProps) => (
    <div className={styles.item}>
        <div className={styles.name}>{name}</div>
        <div className={classNames(styles.value, valueClass)}>{value}</div>
    </div>
);